import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import type { DocChatEvalCase } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/buildDocChatEvalCase'
import { useCallback } from 'react'

export class EvalCaseSaveError extends Error {
  constructor(public readonly detail: string) {
    super(detail)
    this.name = 'EvalCaseSaveError'
  }
}

/** POST one case to `/api/eval/cases`, the same write the eval page uses. */
export async function postEvalCase(
  baseUrl: string,
  authorization: string,
  evalCase: DocChatEvalCase
): Promise<void> {
  const response = await fetch(`${baseUrl}/api/eval/cases`, {
    method: 'POST',
    headers: {
      Authorization: authorization,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(evalCase),
  })
  if (response.ok) return
  const text = await response.text().catch(() => response.statusText)
  let detail = text || response.statusText
  try {
    const parsed = JSON.parse(text) as { detail?: unknown }
    if (typeof parsed.detail === 'string' && parsed.detail.trim()) {
      detail = parsed.detail
    }
  } catch {
    // Keep the raw response text.
  }
  throw new EvalCaseSaveError(detail)
}

export function useSaveEvalCase(): (
  evalCase: DocChatEvalCase
) => Promise<void> {
  const { LLM_SERVICE } = useRuntimeVariables()
  const { authorization } = useGeckoAuth()
  return useCallback(
    (evalCase) => postEvalCase(LLM_SERVICE, authorization ?? '', evalCase),
    [LLM_SERVICE, authorization]
  )
}
